import React from 'react';
import { Tabs } from 'tea-component';
import './EngagementTypeSegment.scss';

export interface IEngagementTypeOption {
  text: string;
  value: string;
}

interface IEngagementTypeSegmentProps {
  value: string;
  options: IEngagementTypeOption[];
  onChange: (value: string) => void;
}

export default function EngagementTypeSegment({
  value,
  options,
  onChange,
}: IEngagementTypeSegmentProps) {
  return (
    <Tabs
      className="dbo-video-engagement-segment segment-light"
      activeId={value}
      onActive={(tab) => {
        if (tab?.id) {
          onChange(tab.id);
        }
      }}
      tabs={options.map((option) => ({
        id: option.value,
        label: option.text,
      }))}
    />
  );
}
